// import React, { useEffect, useState } from "react";
// import { FaEnvelope, FaCheckCircle, FaBook } from "react-icons/fa";
// import "./Myinterests.css";

// export default function MyInterests() {
//   const [userCourses, setUserCourses] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const storedUser = localStorage.getItem("user");
//   const user = storedUser ? JSON.parse(storedUser) : null;

//   useEffect(() => {
//     if (!user?.uid) return;

//     const fetchUserCourses = async () => {
//       try {
//         const res = await fetch(
//           `https://agepcoatings.com/payments/mycourses/${user.uid}`
//         );
//         const data = await res.json();

//         if (data.success) {
//           setUserCourses(data.courses);
//         } else {
//           setUserCourses([]);
//         }
//       } catch (err) {
//         console.error("❌ Error fetching user courses:", err);
//         setUserCourses([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUserCourses();
//   }, [user]);

//   if (!user) {
//     return (
//       <div className="container my-5 myinterests-wrapper">
//         <div className="alert alert-warning text-center">
//           🔒 Please login/register to view your courses.
//         </div>
//       </div>
//     );
//   }

//   if (loading) {
//     return (
//       <div className="container my-5 myinterests-wrapper">
//         <div className="alert alert-info text-center">⏳ Loading...</div>
//       </div>
//     );
//   }

//   if (!userCourses || userCourses.length === 0) {
//     return (
//       <div className="container my-5 myinterests-wrapper">
//         <div className="alert alert-danger text-center">
//           📭 You have not purchased any courses yet.
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container my-5 myinterests-wrapper">
//       <h2 className="text-center title fw-bold">🎓 My Courses</h2>

//       <div className="card shadow-sm mb-4 rounded-3">
//         <div className="card-body">
//           <p>
//             <FaEnvelope /> <strong>Email:</strong> {user?.email || "N/A"}
//           </p>
//           <p>
//             <FaBook /> <strong>Total Courses:</strong> {userCourses.length}
//           </p>

//           <ul className="list-group mt-3">
//             {userCourses.map((course, index) => (
//               <li key={index} className="list-group-item d-flex align-items-center">
//                 <img
//                   src={course.image}
//                   alt={course.courseName}
//                   style={{ width: "60px", height: "60px", marginRight: "10px", objectFit: "cover", borderRadius: "8px" }}
//                 />
//                 <div>
//                   <strong>{course.courseName}</strong>
//                   <p className="mb-1">{course.courseDescription?.slice(0, 80)}...</p>
//                   <span className="badge bg-success">
//                     <FaCheckCircle className="me-1" />
//                     {course.status}
//                   </span>
//                 </div>
//               </li>
//             ))}
//           </ul>
//         </div>
//       </div>
//     </div>
//   );
// }
// import React, { useEffect, useState } from "react";
// import "bootstrap-icons/font/bootstrap-icons.css"; // Make sure Bootstrap Icons are installed
// import "./Myinterests.css";

// export default function MyInterests() {
//   const [userCourses, setUserCourses] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const storedUser = localStorage.getItem("user");
//   const user = storedUser ? JSON.parse(storedUser) : null;

//   useEffect(() => {
//     if (!user?.uid) return;

//     const fetchUserCourses = async () => {
//       try {
//         const res = await fetch(
//           `https://agepcoatings.com/payments/usermycourses/${user.uid}`
//         );
//         const data = await res.json();
//         console.log("API Response:", data);

//         if (data.success) {
//           setUserCourses(data.courses);
//         } else {
//           setUserCourses([]);
//         }
//       } catch (err) {
//         console.error("❌ Error fetching user courses:", err);
//         setUserCourses([]);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchUserCourses();
//   }, [user]);

//   if (!user) {
//     return (
//       <div className="container my-5 myinterests-wrapper">
//         <div className="alert alert-warning text-center">
//           🔒 Please login/register to view your courses.
//         </div>
//       </div>
//     );
//   }

//   if (loading) {
//     return (
//       <div className="container my-5 myinterests-wrapper">
//         <div className="alert alert-info text-center">⏳ Loading...</div>
//       </div>
//     );
//   }

//   if (!userCourses || userCourses.length === 0) {
//     return (
//       <div className="container my-5 myinterests-wrapper">
//         <div className="alert alert-danger text-center">
//           📭 You have not purchased any courses yet.
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="container my-5 myinterests-wrapper">
//       <h2 className="text-center title fw-bold">🎓 My Courses</h2>

//       <ul className="list-group mt-3">
//         {userCourses.map((course, index) => (
//           <li key={index} className="list-group-item d-flex align-items-center">
//             <i className="bi bi-check-circle text-success me-2"></i>
//             <div>
//               <strong>{course.courseTitle}</strong> – {course.levelBadge}
//             </div>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// }
import React, { useEffect, useState } from "react"; 
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Myinterests.css";

export default function MyInterests() {
  const [userCourses, setUserCourses] = useState([]);
  const [loading, setLoading] = useState(true);

  const storedUser = localStorage.getItem("user");
  const user = storedUser ? JSON.parse(storedUser) : null;

  useEffect(() => {
    if (!user?.uid) return;

    const fetchUserCourses = async () => {
      try {
        const res = await fetch(
          `https://agepcoatings.com/payments/usermycourses/${user.uid}`
        );
        const data = await res.json();

        if (data.success) {
          // Filter out courses with status "incart"
          const filteredCourses = data.courses.filter(
            (c) => c.status !== "incart"
          );
          setUserCourses(filteredCourses);
        } else {
          setUserCourses([]);
        }
      } catch (err) {
        console.error("❌ Error fetching user courses:", err);
        setUserCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchUserCourses();
  }, [user]);

  if (!user) {
    return (
      <div className="container my-5 myinterests-wrapper">
        <div className="alert alert-warning text-center">
          🔒 Please login/register to view your courses.
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="container my-5 myinterests-wrapper">
        <div className="alert alert-info text-center">⏳ Loading...</div>
      </div>
    );
  }

  if (!userCourses || userCourses.length === 0) {
    return (
      <div className="container my-5 myinterests-wrapper">
        <div className="alert alert-danger text-center">
          📭 You have not purchased any courses yet.
        </div>
      </div>
    );
  }

  return (
    <div className="container my-5 myinterests-wrapper">
      <h2 className="text-center title fw-bold">🎓 My Courses</h2>

      <ul className="list-group mt-3">
        {userCourses.map((course, index) => {
          const { courseTitle, levelBadge, mode, status } = course;

          // Decide row background and optional muted message
          let rowBgClass = "";
          let mutedMessage = "";

          if ((mode === "full" && status === "full") || (mode === "remaining" && status === "full")) {
            rowBgClass = "bg-success bg-opacity-25"; // green for full/remaining
          } else if (mode === "partial") {
            rowBgClass = "bg-warning bg-opacity-25"; // yellow for partial
            mutedMessage = "Please complete remaining payment";
          }

          return (
            <li key={index} className={`list-group-item d-flex flex-column align-items-start ${rowBgClass}`}>
              <div className="d-flex align-items-center w-100">
                <i className={`bi ${mode === "partial" ? "bi-exclamation-circle text-warning" : "bi-check-circle text-success"} me-2`}></i>
                <strong>{courseTitle}</strong> – {levelBadge}
              </div>
              {mutedMessage && <small className="text-muted mt-1">{mutedMessage}</small>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
